<template>
    <div>
        <router-view v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Module',
  created: function () {
    this.$emit('activeMenu', '/admin/modules')
    this.$emit('newLink', '/admin/modules/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/Module.vue